import React from "react";

import ReusableModal from "components/Modals/ReusableModal";


const DeleteCommissionConfiguration = ({
    isOpen,
    onClose,
    onConfirm,
    configuration,
}) => {
    const percentage =
        configuration?.commission_percentage ??
        0;

    const bodyMessage = `
        Are you sure you want to delete the
        <strong>${percentage}% commission configuration</strong>?
        This action cannot be undone.
    `;

    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Confirm Delete"
            bodyMessage={
                <div
                    dangerouslySetInnerHTML={{
                        __html:
                            bodyMessage,
                    }}
                />
            }
            confirmLabel="Confirm"
            cancelLabel="Cancel"
        />
    );
};

export default DeleteCommissionConfiguration;